import { render, staticRenderFns } from "./YA_Content_GO.vue?vue&type=template&id=cf8bb0dc&scoped=true"
import script from "./YA_Content_GO.vue?vue&type=script&lang=js"
export * from "./YA_Content_GO.vue?vue&type=script&lang=js"
import style0 from "./YA_Content_GO.vue?vue&type=style&index=0&id=cf8bb0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8bb0dc",
  null
  
)

export default component.exports